import { Utils } from './../../helper/utils';
import { userBALService } from '../user.bal';
import Moment from 'moment';
const {config} = require('../../config');

const True = true;
const False = false;

const getColumnList = async (params) => {
    return  {
        'SnPRatingMap': 
        {'AAA': 1, 'AA+': 2, 'AA': 3, 'AA-': 4, 'A+': 5, 'A': 6, 'A-': 7, 'BBB+': 8, 'BBB': 9, 'BBB-': 10, 'BB+': 11, 'BB': 12, 'BB-': 13, 'B+': 14, 'B': 15, 'B-': 16, 'CCC+': 17, 'CCC': 18, 'CCC-': 19, 'CC': 20, 'C': 21, 'D': 22}, 
        'columnSpecs': [
            {'display': 'Fund', 'col': 'Fund', 'agg': 'uniq', 'ag-grid': true, minWidth : 90, maxWidth : 95, 'rowGroup': true, 'format': 'fundFormat', hide : true},

            {'display': 'MTD PNL.Price', 'col': 'pnl price', 'agg': 'sumif', 'fltr': {'is current month': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'MTD PNL.Int', 'col': 'pnl interest', 'agg': 'sumif', 'fltr': {'is current month': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'MTD PNL.FX', 'col': 'pnl fx', 'agg': 'sumif', 'fltr': {'is current month': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'MTD PNL.Funding', 'col': 'pnl financing', 'agg': 'sumif', 'fltr': {'is current month': True, 'is deal hedge': False}, 'format': 'millionsFormat2D', 'ag-grid': True, width: 100},
            {'display': 'MTD PNL.Deal Hedge', 'col': 'pnl total deal', 'agg': 'sumif', 'fltr': {'is current month': True, 'is deal hedge': True}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'MTD PNL.Other', 'col': 'pnl other', 'agg': 'sumif', 'fltr': {'is current month': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'MTD PNL.Deal', 'col': 'pnl total deal', 'agg': 'sumif', 'fltr': {'is current month': True}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            
            {'display': 'QTD PNL.Price', 'col': 'pnl price', 'agg': 'sumif', 'fltr': {'is current quarter': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'QTD PNL.Int', 'col': 'pnl interest', 'agg': 'sumif', 'fltr': {'is current quarter': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'QTD PNL.FX', 'col': 'pnl fx', 'agg': 'sumif', 'fltr': {'is current quarter': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'QTD PNL.Funding', 'col': 'pnl financing', 'agg': 'sumif', 'fltr': {'is current quarter': True, 'is deal hedge': False}, 'format': 'millionsFormat2D', 'ag-grid': True, width: 100},
            {'display': 'QTD PNL.Deal Hedge', 'col': 'pnl total deal', 'agg': 'sumif', 'fltr': {'is current quarter': True, 'is deal hedge': True}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'QTD PNL.Other', 'col': 'pnl other', 'agg': 'sumif', 'fltr': {'is current quarter': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'QTD PNL.Deal', 'col': 'pnl total deal', 'agg': 'sumif', 'fltr': {'is current quarter': True}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            
            {'display': 'YTD PNL.Price', 'col': 'pnl price', 'agg': 'sumif', 'fltr': {'is current year': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'YTD PNL.Int', 'col': 'pnl interest', 'agg': 'sumif', 'fltr': {'is current year': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'YTD PNL.FX', 'col': 'pnl fx', 'agg': 'sumif', 'fltr': {'is current year': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'YTD PNL.Funding', 'col': 'pnl financing', 'agg': 'sumif', 'fltr': {'is current year': True, 'is deal hedge': False}, 'format': 'millionsFormat2D', 'ag-grid': True, width: 100},
            {'display': 'YTD PNL.Deal Hedge', 'col': 'pnl total deal', 'agg': 'sumif', 'fltr': {'is current year': True, 'is deal hedge': True}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'YTD PNL.Other', 'col': 'pnl other', 'agg': 'sumif', 'fltr': {'is current year': True, 'is deal hedge': false}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
            {'display': 'YTD PNL.Deal', 'col': 'pnl total deal', 'agg': 'sumif', 'fltr': {'is current year': True}, 'format': 'millionsFormat2D', 'ag-grid': true, width: 100},
        ]};
}

export const dealPerformanceSummaryBALService = {
     getPositions
    ,getColumnList
    ,getRowData
    ,getAutoGroupColumnDef
};

function getAutoGroupColumnDef(params) {
    return {
         headerName: ''
        ,field: 'deal'
        ,pinned: 'left'
        ,resizable: false
        ,hide: false
        ,width: 70
        ,display: 'Fund'
        ,cellRendererParams:  { suppressCount: true } 
       };    
}

function getRowData(params) {
    return getPositions(params);
}

function getPositions(params) {
    var {AsOfDate, Frequency} = params;
    const requestOptions = { method: 'GET', headers: userBALService.getAuthHeader() };
    var asdate = AsOfDate ? Moment(AsOfDate).format('YYYYMMDD') : '';
    Frequency = Frequency ? Frequency : '';
    return fetch(`${config.apiUrl}/allposition?asofdate=${asdate}&frequency=${Frequency}`, requestOptions).then(Utils.handleResponse).then(positions => { return positions; });
}